var SDK_VERSION = '7.13.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
